import { defineMessages } from 'react-intl'

const scope = 'procurify.platform.discover-more.features.promoteApOnPoExport'

export default defineMessages({
  badge: {
    id: `${scope}.badge`,
    defaultMessage: 'Add-on',
  },
  headline: {
    id: `${scope}.headline`,
    defaultMessage: 'Matching {recordCount, number} records by hand?',
  },
  body: {
    id: `${scope}.body`,
    defaultMessage:
      'Accounts Payable reconciles POs, receipts and invoices inside Procurify, so this export stops being a monthly job.',
  },
  learnMore: {
    id: `${scope}.learnMore`,
    defaultMessage: 'Learn more',
  },
  later: {
    id: `${scope}.later`,
    defaultMessage: 'Later',
  },
})
